const Styles = {
    'OverlayHeaderText': 'OverlayHeaderText_OverlayHeaderText--bfd9dece'
};

export default Styles;